/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScanStatus } from './ScanStatus';
import {
    ScanStatusFromJSON,
    ScanStatusFromJSONTyped,
    ScanStatusToJSON,
} from './ScanStatus';
import type { TicketType } from './TicketType';
import {
    TicketTypeFromJSON,
    TicketTypeFromJSONTyped,
    TicketTypeToJSON,
} from './TicketType';

/**
 * A ticket scan in the system health view. Never carries the barcode.
 * @export
 * @interface RecentTicketScan
 */
export interface RecentTicketScan {
    /**
     * 
     * @type {string}
     * @memberof RecentTicketScan
     */
    details?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RecentTicketScan
     */
    createdAt: Date;
    /**
     * 
     * @type {TicketType}
     * @memberof RecentTicketScan
     */
    ticketType: TicketType;
    /**
     * 
     * @type {ScanStatus}
     * @memberof RecentTicketScan
     */
    status: ScanStatus;
    /**
     * 
     * @type {string}
     * @memberof RecentTicketScan
     */
    deviceLookupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecentTicketScan
     */
    playerLookupId?: string | null;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof RecentTicketScan
     */
    scanId: string;
}



/**
 * Check if a given object implements the RecentTicketScan interface.
 */
export function instanceOfRecentTicketScan(value: object): value is RecentTicketScan {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('ticketType' in value) || value['ticketType'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('scanId' in value) || value['scanId'] === undefined) return false;
    return true;
}

export function RecentTicketScanFromJSON(json: any): RecentTicketScan {
    return RecentTicketScanFromJSONTyped(json, false);
}

export function RecentTicketScanFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecentTicketScan {
    if (json == null) {
        return json;
    }
    return {
        
        'details': json['details'] == null ? undefined : json['details'],
        'createdAt': (new Date(json['createdAt'])),
        'ticketType': TicketTypeFromJSON(json['ticketType']),
        'status': ScanStatusFromJSON(json['status']),
        'deviceLookupId': json['deviceLookupId'] == null ? undefined : json['deviceLookupId'],
        'playerLookupId': json['playerLookupId'] == null ? undefined : json['playerLookupId'],
        'scanId': json['scanId'],
    };
}

export function RecentTicketScanToJSON(value?: RecentTicketScan | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'details': value['details'],
        'createdAt': ((value['createdAt']).toISOString()),
        'ticketType': TicketTypeToJSON(value['ticketType']),
        'status': ScanStatusToJSON(value['status']),
        'deviceLookupId': value['deviceLookupId'],
        'playerLookupId': value['playerLookupId'],
        'scanId': value['scanId'],
    };
}

